<template>
  <header :class="headerMode">
    <div>
      <h1>TODO</h1>
      <img
        v-if="mode === 'light'"
        src="../../assets/images/icon-moon.svg"
        alt="moon"
        @click="toggleMode"
      />

      <img
        v-if="mode === 'dark'"
        src="../../assets/images/icon-sun.svg"
        alt="sun"
        @click="toggleMode"
      />
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      mode: "light",
    };
  },

  methods: {
    toggleMode() {
      if (this.mode === "light") {
        this.mode = "dark";
      } else if (this.mode === "dark") {
        this.mode = "light";
      }

      this.$emit("mode", this.mode);
    },
  },

  computed: {
    headerMode() {
      return this.mode === "light" ? "header-light" : "header-dark";
    },
  },
};
</script>

<style scoped lang="scss">
header {
  max-width: 144rem;
  height: 30rem;
  padding-top: 7rem;
  margin: 0 auto;
  position: relative;
}

.header-light {
  background-image: url("../../assets/images/bg-desktop-light.jpg");
}

.header-dark {
  background-image: url("../../assets/images/bg-desktop-dark.jpg");
}

div {
  max-width: 54.1rem;
  max-height: 4.8rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 600px) {
    width: 32rem;
    height: 2rem;
  }
}

h1 {
  max-width: 16.7rem;
  max-height: 4rem;
  color: #fff;
}

img {
  cursor: pointer;
}
</style>
